import Vue from 'vue'
import VueRouter from 'vue-router'
import Forbidden from '../components/pages/Forbidden.vue'
import NotFound from '../components/pages/NotFound.vue'
import InternalServerError from '../components/pages/InternalServerError.vue'
import Maintenance from '../components/pages/Maintenance.vue'
import BadGateway from '../components/pages/BadGateway.vue'
import Home from '../components/pages/Home.vue'
import Talkshows from '../components/pages/Talkshows.vue'
import TalkshowsReport from '../components/pages/TalkshowsReport.vue'
import ReportFujifilm from '../components/pages/reports/ReportFujifilm.vue'
import ReportNikon from '../components/pages/reports/ReportNikon.vue'
import ReportRaytrek from '../components/pages/reports/ReportRaytrek.vue'
import Exhibitors from '../components/pages/Exhibitors.vue'
import Artworks from '../components/pages/Artworks.vue'
import ArtworkCategory from '../components/pages/ArtworkCategory.vue'
import ArtworksWinner from '../components/pages/ArtworksWinner.vue'
import Specials from '../components/pages/Specials.vue'
import SpecialExhibition from '../components/pages/SpecialExhibition.vue'
import Photobook from '../components/pages/Photobook.vue'
import PhotobookTalkshow from '../components/pages/PhotobookTalkshow.vue'
import PhotobookExhibition from '../components/pages/PhotobookExhibition.vue'
import UpdateInfo from '../components/pages/UpdateInfo.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: '東京カメラ部2020写真展 Online Exhibition「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '2019年に東京カメラ部とその分室で9億人を超える人々が約2,300万作品の中から選んだ作品「10選2019」を中心に新作、自信作を追加。更に2012年、2013年、2014年、2015年、2016年、2017年、2018年に選ばれた10選メンバーを加えた、10選8世代による合同展示。フォトコンテスト「日本写真100景」入選作品「"My Precious" Photo Contest」入選作品を加え、約289作品を展示。' }
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: Forbidden
  },
  {
    path: '/not-found',
    name: 'notFound',
    component: NotFound
  },
  {
    path: '/internal-server-error',
    name: 'internalServerError',
    component: InternalServerError
  },
  {
    path: '/bad-gateway',
    name: 'badGateway',
    component: BadGateway
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: Maintenance
  },
  {
    path: '/artworks/:awardTypeCode/:id/images/:winningWorkId',
    name: 'artworksWinnerImage',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/artworks/:awardTypeCode/:id/portfolios/:portfolioId',
    name: 'artworksWinnerPortfolios',
    component: ArtworksWinner,
    meta: { title: ' | ポートフォリオ | 東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/artworks/:awardTypeCode/:id',
    name: 'artworksWinner',
    component: ArtworksWinner,
    meta: { title: ' | 作品展示 | 東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/artworks/Tcc10Sen',
    name: 'tcc10Sen',
    component: ArtworkCategory,
    meta: { title: '東京カメラ部10選 | 作品展示 | 東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/artworks/Japan100Views',
    name: 'japan100Views',
    component: ArtworkCategory,
    meta: { title: '日本写真100景 | 作品展示 | 東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/artworks/MyPrecious',
    name: 'myPrecious',
    component: ArtworkCategory,
    meta: { title: '"My Precious" Photo Contest | 作品展示 | 東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/exhibitors',
    name: 'exhibitors',
    component: Exhibitors,
    meta: { title: '展示者一覧 | 作品展示 | 東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/artworks',
    name: 'artworks',
    component: Artworks,
    meta: { title: '作品展示 | 東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/talkshows',
    name: 'talkshows',
    component: Talkshows,
    meta: { title: 'トークショーアーカイブ動画 | オンライントークショー |  東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/talkshows/report',
    name: 'talkshowsReport',
    component: TalkshowsReport,
    meta: { title: 'トークショーレポート | オンライントークショー |  東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/talkshows/report_fujifilm',
    name: 'reportFujifilm',
    component: ReportFujifilm,
    meta: { title: '富士フイルムトークショーレポート | オンライントークショー |  東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/talkshows/report_nikon',
    name: 'reportNikon',
    component: ReportNikon,
    meta: { title: 'ニコンイメージングジャパントークショーレポート | オンライントークショー |  東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/talkshows/report_raytrek',
    name: 'reportRaytrek',
    component: ReportRaytrek,
    meta: { title: 'raytrekトークショーレポート | オンライントークショー |  東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/specials',
    name: 'specials',
    component: Specials,
    meta: { title: '特別展示 |  東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/specials/:id',
    name: 'specialExhibition',
    component: SpecialExhibition,
    meta: { title: ' | 特別展示 |  東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/specials/:id/images/:specialExhibitionsWorkId',
    name: 'specialExhibitionImage',
    component: SpecialExhibition,
    meta: { title: ' | 特別展示 |  東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/photobook',
    name: 'photobook',
    component: Photobook,
    meta: { title: '公式写真集の紹介 | 公式写真集 |  東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/photobook/talkshow',
    name: 'photobookTalkshow',
    component: PhotobookTalkshow,
    meta: { title: '発売記念オンライントークショー | 公式写真集 | 東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/photobook/exhibition',
    name: 'photobookExhibition',
    component: PhotobookExhibition,
    meta: { title: '10選2019作品プリント展示 | 公式写真集 | 東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '/updateinfo',
    name: 'updateinfo',
    component: UpdateInfo,
    meta: { title: 'アップデート情報 | 東京カメラ部2020写真展 Online Exhibition 「それでも世界は美しい。 - This Cruel Yet Beloved World -」', desc: '' }
  },
  {
    path: '*',
    redirect: '/not-found'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition // 戻るボタン対応
    // 画像詳細とポートフォリオから復帰した場合は、元のスクロール位置を保持する
    if (
      (to && to.path && to.path.indexOf('/images/') >= 0) ||
      (from && from.path && from.path.indexOf('/images/')) >= 0 ||
      (to && to.path && to.path.indexOf('/portfolios/') >= 0) ||
      (from && from.path && from.path.indexOf('/portfolios/')) >= 0
    ) {
      return null
    } else {
      // スクロール位置を左上にリセット
      return { x: 0, y: 0 }
    }
  }
})

/*
router.beforeEach(async (to, from, next) => {
})
*/

export default router
